// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topbar {\n  border-bottom: 1px solid #e5e7eb;\n}\n.supporters-search {\n  box-shadow: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
